import styles from './SmartApplyPartnerLogos.module.scss'
import {
  MAX_PARTNER_LOGOS,
  useSmartApplyPartnerLogos
} from '@percent/cause-dashboard/common/hooks/useSmartApplyPartnerLogos/useSmartApplyPartnerLogos'
import type { SmartApplyPartner } from '@percent/cause-dashboard/constants/smartApplyPartnerConfig'
import type { SlotPosition } from './SmartApplyPartnerLogos.types'
export { SMART_APPLY_PARTNER_LOGOS, ADOBE_SUB_PRODUCT_LOGOS } from './partnerLogos'

export const SLOT_POSITIONS: Record<number, SlotPosition[]> = {
  1: [{ left: 54.17, top: 39.06 }],
  2: [
    { left: 12.75, top: 10.14 },
    { left: 52.5, top: 76.03 }
  ],
  3: [
    { left: 12.75, top: 10.14 },
    { left: 68.42, top: 7.5 },
    { left: 52.5, top: 76.03 }
  ],
  4: [
    { left: 12.75, top: 10.14 },
    { left: 68.42, top: 7.5 },
    { left: 54.17, top: 39.06 },
    { left: 21.04, top: 56.75 }
  ],
  5: [
    { left: 12.75, top: 10.14 },
    { left: 68.42, top: 7.5 },
    { left: 54.17, top: 39.06 },
    { left: 21.04, top: 56.75 },
    { left: 52.5, top: 76.03 }
  ]
}

type SmartApplyPartnerLogosProps = {
  partners?: SmartApplyPartner[]
}

export function SmartApplyPartnerLogos({ partners }: Readonly<SmartApplyPartnerLogosProps> = {}) {
  const allLogos = useSmartApplyPartnerLogos()
  const logos = partners ? allLogos.filter(({ partner }) => partners.includes(partner)) : allLogos
  const positions = SLOT_POSITIONS[Math.min(logos.length, MAX_PARTNER_LOGOS)]

  if (!positions) {
    return null
  }

  return (
    <div className={styles.graphic} data-testid="smart-apply-partner-logos">
      {logos.map(({ partner, logo }, index) => (
        <div
          key={partner}
          className={styles.logoSlot}
          style={{ left: `${positions[index].left}%`, top: `${positions[index].top}%` }}
          data-testid={`smart-apply-logo-${partner}`}
        >
          <img src={logo} alt="" className={styles.logo} />
        </div>
      ))}
    </div>
  )
}
